import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('ipl_token');
        const savedUser = localStorage.getItem('ipl_user');
        if (token && savedUser) {
            try {
                setUser(JSON.parse(savedUser));
            } catch (e) { /* ignore */ }
            API.get('/auth/me').then(res => {
                setUser(res.data);
                localStorage.setItem('ipl_user', JSON.stringify(res.data));
            }).catch(() => {
                localStorage.removeItem('ipl_token');
                localStorage.removeItem('ipl_user');
                setUser(null);
            }).finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const login = async (email, password) => {
        const res = await API.post('/auth/login', { email, password });
        localStorage.setItem('ipl_token', res.data.token);
        localStorage.setItem('ipl_user', JSON.stringify(res.data.user));
        setUser(res.data.user);
        return res.data;
    };

    const register = async (name, email, password) => {
        const res = await API.post('/auth/register', { name, email, password });
        localStorage.setItem('ipl_token', res.data.token);
        localStorage.setItem('ipl_user', JSON.stringify(res.data.user));
        setUser(res.data.user);
        return res.data;
    };

    const logout = () => {
        localStorage.removeItem('ipl_token');
        localStorage.removeItem('ipl_user');
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) throw new Error('useAuth must be used within AuthProvider');
    return context;
}
